import { ContentBlock } from "../../types/contentBlock";
import { RelationBlock } from "../../types/relationBlock";

export const relationBlockQuery = `
    _type == "relationBlock" => {
        title,
        sortOrder,
        _type,
    },
`

export const isRelationBlock = (solution: ContentBlock): solution is RelationBlock => {
    return solution._type === 'relationBlock';
}